import jsPDF from 'jspdf';
import PDF from 'vue-pdf'
/* 
getPTP --> getPdfTotalPages - Obtiene el total de páginas de un PDF
generarPDF --> generatePDF - Genera un PDF a partir de un elemento HTML 

*/

export function getPTP(PDF_ID) {
    return new Promise((resolve, reject) => {
        // Carga del PDF
        const loadingTask = PDF.createLoadingTask('/api/File/' + PDF_ID);
        // Obtención del total de páginas
        loadingTask.promise.then((pdf) => {
            resolve(pdf.numPages);
        }).catch((error) => {
            reject(error);
        })
    });
}

export async function generarPDF(elemento , PDF_ID, PDF_Titulo) {
    try {
        // Crear una instancia de jsPDF con las opciones personalizadas
        var pdf = new jsPDF({
            orientation: 'p',
            unit: 'px',
            format: 'letter',
            hotfixes: ['px_scaling'],
        });

        // Margen en píxeles (aproximadamente 0.5 pulgadas)
        var marginTop = 36;
        var marginRight = 10;
        var marginBottom = 36;
        var marginLeft = 10;
        // Calcular el ancho y alto disponibles para el contenido (considerando los márgenes)
        var contentWidth = pdf.internal.pageSize.getWidth() - (marginLeft + marginRight);
        var contentHeight = pdf.internal.pageSize.getHeight() - (marginTop + marginBottom);

        // Asegurar que el div "elementoPDF" tenga el tamaño adecuado para cuadrar con los márgenes
        elemento.style.width = contentWidth + 'px';
        elemento.style.height = contentHeight + 'px';


        // Agregar el contenido al PDF con el ancho y alto ajustados al tamaño deseado
        pdf.html(elemento, {
            callback: function (pdf) {
                // Agregar el número de páginas al PDF
                const paginas_certificado = pdf.internal.getNumberOfPages();

                // Agregar numeración de página en el bucle de creación del PDF
                for (var i = 1; i <= paginas_certificado; i++) {
                    pdf.setPage(i);
                    pdf.setFontSize(10);
                    var pageWidth = pdf.internal.pageSize.getWidth();
                    var pageHeight = pdf.internal.pageSize.getHeight();
                    pdf.text('Página ' + i + ' de ' + paginas_certificado, pageWidth - 50, pageHeight - 20, { align: 'right' });
                }

                // Guardar el PDF
                pdf.save(`${PDF_ID}_${PDF_Titulo}.pdf`);
            },
            margin: [marginTop, marginRight, marginBottom, marginLeft],
            autoPaging: 'text',
        });

    } catch (error) {
        console.error('Error al generar el PDF:', error);
    }
}

